import React from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Chip,
  Paper
} from '@mui/material';
import {
  StoreOutlined,
  Add as AddIcon
} from '@mui/icons-material';
import { ZERDE_PRIMARY } from '../types';

interface UserPharmaciesSectionProps {
  /** users.edit_pharmacy в зоне оператора: этим же правом сервер меняет myPharmacy */
  canEdit: boolean;
  newPharmacyToAdd: string;
  setNewPharmacyToAdd: (v: string) => void;
  handleAddPharmacyChip: () => void;
  handleRemovePharmacyChip: (num: string) => void;
  myPharmacy: string;
}

export const UserPharmaciesSection: React.FC<UserPharmaciesSectionProps> = ({
  canEdit,
  newPharmacyToAdd,
  setNewPharmacyToAdd,
  handleAddPharmacyChip,
  handleRemovePharmacyChip,
  myPharmacy
}) => {
  return (
    <Box id="user-section-pharmacies" sx={{ scrollMarginTop: '60px' }}>
      <Paper elevation={0} sx={{ p: 3.5, bgcolor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <StoreOutlined sx={{ color: ZERDE_PRIMARY, fontSize: 20 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
            Подчиненные аптеки куратора
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
          Список номеров аптек, доступных сотруднику для просмотра и контроля
        </Typography>

        {canEdit && (
          <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
            <TextField
              size="small"
              label="Номер аптеки"
              placeholder="Например: 12"
              value={newPharmacyToAdd}
              onChange={(e) => setNewPharmacyToAdd(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleAddPharmacyChip();
              }}
              InputProps={{ sx: { bgcolor: '#f8fafc', borderRadius: '8px' } }}
              sx={{ width: 220 }}
            />
            <Button
              variant="outlined"
              onClick={handleAddPharmacyChip}
              startIcon={<AddIcon />}
              sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600, height: 40 }}
            >
              Добавить
            </Button>
          </Box>
        )}

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, minHeight: 60, p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
          {myPharmacy ? (
            myPharmacy.split(',').map(s => s.trim()).filter(Boolean).map((pNum) => (
              <Chip
                key={pNum}
                label={`Аптека №${pNum}`}
                onDelete={canEdit ? () => handleRemovePharmacyChip(pNum) : undefined}
                color="primary"
                variant="outlined"
                sx={{ fontWeight: 600, bgcolor: '#ffffff', borderRadius: '6px' }}
              />
            ))
          ) : (
            <Typography variant="body2" sx={{ color: '#94a3b8', m: 'auto' }}>
              Нет привязанных аптек
            </Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default UserPharmaciesSection;
